import { debounce } from './../utils/index'
 
/**
 * dmp上报参数
 */
let dmpParams = {

    /* 传入参数 */

    autoVisit: true,        // 是否自动上报visit

    autoPv: true,           // 是否自动上报pv

    autoTimeline: true,     // 是否自动上报timeline

    autoLeave: true,        // 是否自动上报leave

    /* End - 传入参数 */

    clickId: '',            // 点击id

    DEBOUNCE_DELAY: 300,    // 常量：防抖延迟

    THROTTLE_DELAY: 50,     // 常量：节流延迟

    MULTI_SPLITER: ',',     // 常量：批量上报分割符
   
    list_dmp_multi_pop: [], // 批量曝光数据列表

    list_pop_remove_events:[],      // 曝光事件移除列表

    list_click_remove_events: [],   // 点击事件移除列表

    time_visit_begin: null,    // pv上报时的时间

    time_pv_begin: null,    // pv上报时的时间

    list_visited_path: [],   // 访问过的页面列表

    /**
     * 点击上报时，缓存下pv需要数据
     */
    cache_for_pv: {

        title: '',

        targetid: '',

        from: '',

        targettype: ''
    },

    /**
     * pv上报时，缓存下timeline需要数据
     */
    cache_for_timeline: {

        title: '',

        targetid: '',

        from: '',

        targettype: ''
    }

}

let dmpMutations = {
    /**
     * 
     * @param {*} data 
     * @param {*} action 
     */
    setCache( data, action ) {
        let cache = dmpParams[`cache_for_${action}`]
        for (let attr in cache) {
            cache[attr] = data[attr]
        }
    },

    /**
     * 获取缓存文章数据
     * @param {Object} data 传入的上报参数
     * @param {String} action 上报行为，如pv、timeline
     */
    getCache( data, action ) {
        let cache = dmpParams[`cache_for_${action}`]
        for (let attr in cache) {
            data[attr] = cache[attr]
        }
        return data
    },

    /**
     * 清空缓存
     * @param {String} action 
     */
    clearCache( action ) {
        let cache = dmpParams[`cache_for_${action}`]
        for (let attr in cache) {
            cache[attr] = ''
        }
    },
    
    isCahce( action ) {
        return Boolean(dmpParams[`cache_for_${action}`].title)
    },

    removeEvents() {
        let pop_list = dmpParams.list_pop_remove_events.slice(0),
        click_list = dmpParams.list_click_remove_events.slice(0)
        
        dmpParams.list_pop_remove_events = []
        dmpParams.list_click_remove_events = []
        
        const remover = () => {
            for (let i = 0, item; item = pop_list[i]; i++) {
                if (typeof item === 'function') item()
            }
    
            for (let i = 0, item; item = click_list[i]; i++) {
                if (typeof item === 'function') item()
            }
        }

        let delay_remover = debounce(remover,100)
        delay_remover()
    }
}

export { dmpParams, dmpMutations }